import { forwardRef } from 'react';

/**
 * A component that uses the `dangerouslySetInnerHTML` attribute behind the scenes to render raw HTML
 * Please use this component only with safe and trusted HTML
 *
 * @param {string} markup The HTML Markup to render
 * @param {string} className Optional className to the parent element
 */
export const Html = forwardRef(({ markup = null, className = null }, ref) => (
    <div
        ref={ref}
        className={className}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: markup }}
    />
));
